module.exports = __webpack_public_path__ + "static/media/editor-admin-open.8b77d161.svg";